import { render } from "./Phone.vue?vue&type=template&id=770cbf14&scoped=true&ts=true"
import script from "./Phone.vue?vue&type=script&lang=ts"
export * from "./Phone.vue?vue&type=script&lang=ts"

import "./Phone.vue?vue&type=style&index=0&id=770cbf14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770cbf14"]])

export default __exports__